export const passwordRules = [
  'auth.password.rule.0',
  'auth.password.rule.1',
  'auth.password.rule.2',
  'auth.password.rule.3',
];
